import { Base, Image, Parse } from '@/components/Core'
import type { BaseProps } from '@/components/Core/Base/Base'
import { Button } from '@/components/Ui'
import TeaserCardFragment from '@/lib/fragments/teaser-card'
import { Lib } from '@/types'
import { MEDIA } from '@config'
import clsx from 'clsx'
import { memo } from 'react'

export interface CardTeaserProps extends BaseProps {
  data: Lib.FragmentOf<typeof TeaserCardFragment>
}

const CardTeaser = ({ data, className, ...props }: CardTeaserProps) => {
  const { image, title, text, link } = data

  return (
    <Base
      className={clsx(
        className,
        'gap-md p-sm grid h-full grid-rows-[auto,1fr] flex-col rounded-lg border border-neutral-500'
      )}
      {...props}
    >
      <Image
        data={image}
        wrap={{ className: '' }}
        fitWrap
        imgClassName="rounded-md"
        sizes={`${MEDIA.sm} 20rem, 40rem`}
        ar="4x3"
      />
      <div className="px-sm flex h-full flex-col justify-between">
        <div className={'content mb-lg'}>
          <h3 className="mb-md uppercase">{title}</h3>
          <div className="text-style-large">
            <Parse html={text} />
          </div>
        </div>
        <div>
          <Button variant="text" transitionType="slide" data={link} />
        </div>
      </div>
    </Base>
  )
}

export default memo(CardTeaser)
